export default function defaultState() {
  return {
    pattern: null,
  }
}
